<template>
    <el-dialog
      :visible.sync="dialogVisible"
      width="25%"
      class="el-dialog-unheader"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :show-close="false"
    >
        <div class="progress-bar-content">
            <span class="bar-text-ellipsis">
                获取文件：{{ file.name }}
            </span>
            <el-button @click="onCancel" class="bar-cancel">取消</el-button>
        </div>
        <el-progress :percentage="percentage" :status="progressStatus" :show-text="false"/>
    </el-dialog>
</template>

<script>
export default {
  name: 'GjwDialogProgressBar',
  data() {
    return {
      dialogVisible: false,
      percentage: 0,
      progressStatus: null,
      operation: '',
      file: {},
      progressTimerId: null,
    }
  },
  methods: {
    async onCancel() {
      // 调用插件取消下载接口
      const res = await this.$desktopClient.CancelTask(this.file.id)
      if (res.code === 'success' && res.data) {
        // 关闭弹框
        this.dialogVisible = false
        this.percentage = 0
        this.progressStatus = null
      }
      // 关闭蒙层
      // await this.$desktopClient.HideMask({ region: 'R_TITLE_BAR' })
    },
    init(spaceId, filePath, file, operation) {
      this.progressStatus = null
      this.file = file
      this.dialogVisible = true
      this.operation = operation
      this.onDownload(spaceId, filePath, file)
    },
    asyncDownload(res, filePath) {
      return new Promise((resolve, reject) => {
        this.$desktopClient.DownloadFileCancelable(res, filePath, true, this.file.id)
          .then((res) => {
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
        // 设置定时器
        this.progressTimerId = setInterval(() => {
          console.log(this.percentage)
          if (this.percentage < 95) {
            this.percentage += 1
          }
        }, 1000)
        // 5分钟后停止定时器
        setTimeout(() => {
          if (this.progressTimerId) {
            clearInterval(this.progressTimerId)
          }
        }, 5000 * 60)
      })
    },
    async onDownload(spaceId, filePath, file) {
      // 开启蒙层
      // await this.$desktopClient.ShowMask({ region: 'R_TITLE_BAR' })
      this.percentage = 0
      try {
        const res = await this.$api.file.versionRecordsDownload(spaceId, file.id)
        if (res) {
          this.percentage = 5
          const rt = await this.asyncDownload(res, filePath)
          if (rt && rt.code === 'success') {
            this.percentage = 100
            if (this.progressTimerId) { clearInterval(this.progressTimerId) }
            this.progressStatus = 'success'
            this.dialogVisible = false
            this.$emit('success', this.operation)
          } else {
            this.percentage = 100
            if (this.progressTimerId) { clearInterval(this.progressTimerId) }
            this.progressStatus = 'exception'
            this.dialogVisible = false
          }
        }
      } catch (e) {
        this.percentage = 0
        if (this.progressTimerId) { clearInterval(this.progressTimerId) }
        this.$message.error('获取下载地址失败')
      } finally {
        this.dialogVisible = false
        // 关闭蒙层
        // await this.$desktopClient.HideMask({ region: 'R_TITLE_BAR' })
      }
    }
  }
}
</script>

<style>
.el-dialog-unheader .el-dialog__header {
  display: none;
}
</style>
<style lang="less" scoped>
.el-dialog {
    .progress-bar-content {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      padding-bottom: 8px;
      .bar-text-ellipsis {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .bar-cancel {
        height: 20px;
        line-height: 0px;
        font-size: 12px;
      }
    }
}
</style>
